import React, { Component } from 'react';
import getContract, { getBusoContract, getOwnerContract }  from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';
import {getBurnTxn, getAutoBuy} from '../../services/activities';
import { json } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Buso extends Component {

    state = {
      burnTxn: [],
      autobuyTxn: [],
      balance: 0,
      totalSupply: 0,
      userAddress: '',
      userId: 0,
      price: 0,
      reserve: 0,
      volume: 0,
      id: 0
    };

    constructor(props) {
      super(props);
      if(props.router.params.id) {
          this.state.userId = props.router.params.id;
      } else {
          this.state.userId = 1;
      }
      this.props.onSetUserId(this.state.userId);
    }

    async componentDidMount() {
      const busoInfoPromise = this.fetchBusoInfo();
      await toast.promise(busoInfoPromise, {
        pending: "Fetching BUSO details from Polygon...",
        success: "BUSO details Fetched! 👌",
        error: "Fetching failed",
      });
      const promise = this.fetchTransactions();
      await toast.promise(promise, {
        pending: "Fetching Transactions please wait...",
        success: "Transactions Fetched! 👌",
        error: "Fetching failed",
      });
    }

    fetchBusoInfo = async () => {
      const busoContract = await getBusoContract();
      const contract = await getContract();

      const userAddress = await contract.getAddressById(this.state.userId);

      let totalSupply = Math.floor(ethers.utils.formatUnits(await busoContract.totalSupply(), 'mwei'));
      totalSupply = this.formatNumber(totalSupply);

      const {price, volume_24h, reserve} = await this.getBusoPrice();

      this.setState({reserve, volume: volume_24h, price, totalSupply, userAddress});
    }

    formatNumber = (number) => {
      const suffixes = ["", "K", " M", "B", "T"];
      const suffixNum = Math.floor(("" + number).length / 3);
      let shortNumber = parseFloat((suffixNum !== 0 ? (number / Math.pow(1000, suffixNum)) : number).toPrecision(4));
      if (shortNumber % 1 !== 0) {
        shortNumber = shortNumber.toFixed(3);
      }
      return shortNumber + " " + suffixes[suffixNum];
    }

    getBusoPrice = async () => {
      try {
        const url = 'https://api.geckoterminal.com/api/v2/networks/polygon_pos/pools/0x240b83e5611350644a9f90f7dafefcdae6958b7f'; // URL for Matic on CoinMarketCap API
        const headers = { 'Accepts': 'application/json' };
        const response = await axios.get(url, { headers });
        console.log(response);
        if (response.status === 200) {
          const price = +parseFloat(response.data.data.attributes.base_token_price_usd).toFixed(5);
          const volume_24h = +parseFloat(response.data.data.attributes.volume_usd.h24).toFixed(2);
          const reserve = +parseFloat(response.data.data.attributes.reserve_in_usd).toFixed(2);
          return {price, volume_24h, reserve};
        } else {
          throw new Error('Failed to retrieve price');
        }
      } catch (error) {
        console.error('Error:', error.message);
        return null;
      }
    }

    addToMetamask = async () => {
        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const wasAdded = await window.ethereum.request({
              method: 'wallet_watchAsset',
              params: {
                type: 'ERC20', // Initially only supports ERC20, but eventually more!
                options: {
                  address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', // The address that the token is at.
                  // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
                  symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
                  decimals: 6, // The number of decimals in the token
                    //   image: tokenImage, // A string url of the token logo
                },
              },
            });
          
            if (wasAdded) {
              console.log('Thanks for your interest!');
            } else {
              console.log('Your loss!');
            }
          } catch (error) {
            console.log(error);
          }
    }

    addBUSOToMetamask = async () => {
      try {
          // wasAdded is a boolean. Like any RPC method, an error may be thrown.
          const wasAdded = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20', // Initially only supports ERC20, but eventually more!
              options: {
                address: '0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2', // The address that the token is at.
                // address: '0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f', // The address that the token is at.
                symbol: 'BUSO', // A ticker symbol or shorthand, up to 5 chars.
                decimals: 6, // The number of decimals in the token
                  //   image: tokenImage, // A string url of the token logo
              },
            },
          });
        
          if (wasAdded) {
            console.log('Thanks for your interest!');
          } else {
            console.log('Your loss!');
          }
        } catch (error) {
          console.log(error);
        }
    }

    handleIdClick = async () => {

    }

    getClass = async () => {

    }

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
              <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                <div className="flex w-full items-start justify-between space-x-10 lg:space-x-2.5 sm:space-x-0 sm:space-y-5 sm:flex-col sm:px-5">
                  <div className="flex items-start flex-shrink-0 sm:flex-shrink">
                    <div className="flex-shrink-0 relative w-30 h-30 rounded-full cursor-pointer sm:w-15 sm:h-15">
                      <div className="w-26 h-16 sm:h-14 sm:w-14 false rounded-full p-2">
                        <img src="/logo/BUSO.png" />
                      </div>
                    </div>
                    <div className="flex flex-col items-start ml-6 h-full justify-center my-auto">
                      <div className="flex justify-center items-center mb-1 sm:mb-2.5">
                        <h3
                          className="font-bold text-3xl mr-2.5 sm:text-xl cursor-pointer showContractId"
                          style={{ color: "#ffc10c" }}
                        >
                          BUSO
                        </h3>
                      </div>
                      <div className="flex flex-col items-start">
                        <div className="flex items-center mb-1">
                          <span className="text-white font-bold mr-2.5 text-base sm:text-sm showWalletAddress">
                            {/* Price: {this.state.currentPoolId} */}
                            A Deflationary Reward Token
                          </span>
                        </div>
                        <div className="flex items-center mt-4">
                          <span className="text-white font-bold mr-2.5 text-base sm:text-sm showWalletAddress">
                            Price: <span style={{color: "gold"}}>{this.state.price} USD</span> 
                          </span>
                        </div>
                        <div className="flex items-center">
                          <span className="text-white font-bold mr-2.5 text-base sm:text-sm showWalletAddress">
                            24h volume: <span style={{color: "gold"}}>{this.state.volume} USD</span> 
                          </span>
                        </div>
                        <div className="flex items-center">
                          <span className="text-white font-bold mr-2.5 text-base sm:text-sm showWalletAddress">
                            Reserve Liquidity: <span style={{color: "gold"}}>{this.state.reserve} USD</span> 
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="relative flex flex-grow max-w-700px w-full h-full flex-col p-5 justify-between bg-black-light rounded sm:max-w-full">
                    <div className="flex items-center">
                      <h3
                        className="text-base sm:text-sm font-bold mb-2"
                        style={{ fontSize: "20px" }}
                      >
                        Why BUSO and holding it is important:
                      </h3>
                    </div>
                    <div className="md:flex flex-wrap justify-between false">
                      <span className="text-white-00 text-lg font-bold lg:mb-2.5 sm:text-xl">
                        BUSO is a Reward Token and Unique Auto deflationary Coin for Investors of 
                        Solution whose price will always go higher by Auto-Burning and Auto-Buying Algorithm.
                      </span>
                      
                    </div>
                    <div className="md:flex flex-wrap justify-between false">
                      <span className="text-white-00 text-lg font-bold lg:mb-2.5 sm:text-xl">
                        BUSO is a reward token for Investors who build their teams and grow up to bigger Stars.
                        By Holding it you will get more opportunities in participating in future Reward contests.
                      </span>
                    </div>
                    <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                      <div className="flex w-full flex-wrap lg:flex-col">
                      <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                        <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                          <div className="flex items-center">
                            <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                              Total Supply
                            </h4>
                          </div>
                          <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                            {this.state.totalSupply}
                          </span>
                        </div>
                        {/* <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                          <div className="flex items-center">
                            <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                              24h vOLUME
                            </h4>
                          </div>
                          <span
                            className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5"
                            id="yourTeamTreeCount"
                          >
                            {this.state.volume}
                          </span>
                        </div> */}
                        <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                          <div className="flex items-center">
                            <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                              Price Action
                            </h4>
                          </div>
                          <span
                            className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5"
                            id="yourTeamTreeCount"
                          >
                            <a href="https://www.dextools.io/app/en/polygon/pair-explorer/0x240b83e5611350644a9f90f7dafefcdae6958b7f"
                              target="_blank">
                              DexTools Chart
                            </a>
                          </span>
                        </div>
                        <div className="lg:flex-grow sm:max-w-full flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                          <div className="flex items-center">
                            <h4 className="text-base text-lg sm:text-sm sm:whitespace-nowrap">
                              Buy/sell
                            </h4>
                          </div>
                          <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                            <a href="https://quickswap.exchange/#/swap?currency0=0xc2132D05D31c914a87C6611C10748AEb04B58e8F&currency1=0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2&swapIndex=0"
                              target="_blank">
                              Goto Quickswap
                            </a>
                          </span>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
           
          </div>
                    <footer style={{ background: "#18191A", padding: "20px" }}
                            className="flex lg:flex-col items-center mt-auto justify-between lg:justify-start lg:items-start py-10 w-full lg:p-5 lg:pb-9 pb-0 lg:pb-0 z-10">
                            <div className="hidden lg:block mb-7.5">
                                <div className="flex space-x-5 w-full"><a
                                        className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                                        target="_blank" href="https://t.me/sxm2023"><svg
                                            className="w-3 h-3 sm:w-4 sm:h-4" viewBox="0 0 14 12" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path clipRule="evenodd"
                                                d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                                                fill="#fff"></path>
                                        </svg></a>

                                </div>
                            </div>
                            {/* <div id="google_translate_element"></div> */}

                            <span className="text-white-500 text-xs font-normal lg:mb-2.5">© 2023 All Rights
                                Reserved</span>
                        
                    </footer>
            </div>
        );
    }
}
 
export default withWrapper(Buso);